import { render, staticRenderFns } from "./opsy-image.vue?vue&type=template&id=18a5e4f8&"
import script from "./opsy-image.vue?vue&type=script&lang=js&"
export * from "./opsy-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports